/**
 * submitQuestion.js
 * Written by: Alex Kasemir
 */

import alertActions from 'store/alert/actions';
import { getNotifications } from 'store/notification/actions/getNotifications';
import { savePlayedAnswer } from '../savePlayedAnswer';
import request from '../../../request/actions';
import event from '../../../../utils/event';
import { removeQuizQuestion } from '../../../quiz/actions/removeQuizQuestion';


export const SUBMIT_QUESTION_START = `SUBMIT_QUESTION_START`;
export const SUBMIT_QUESTION_SUCCESS = `SUBMIT_QUESTION_SUCCESS`;
export const SUBMIT_QUESTION_FAILURE = `SUBMIT_QUESTION_FAILURE`;

export const submitQuestionStart = (id) => ({
  type: SUBMIT_QUESTION_START,
  id,
});

export const submitQuestionSuccess = (id, result) => ({
  type: SUBMIT_QUESTION_SUCCESS,
  id,
  result,
});

export const submitQuestionFailure = (id, error) => ({
  type: SUBMIT_QUESTION_FAILURE,
  id,
  error,
});

/**
 * Description of the getQuestion action
 */
export const submitQuestion = (data) => {
  return async (dispatch, getState) => {
    dispatch(submitQuestionStart(data.question));
    const requestData = { question: data.question, answer: data.answer.id };
    try {
      const response = await dispatch(request(`/playthroughs/`, `POST`, requestData));
      event(`playthrough`, [`click`, `playthrough`, `${response.data.question_id}`]);
      dispatch(removeQuizQuestion(response.data.question_id));
      if (!getState().user.JWT) {
        await dispatch(savePlayedAnswer(response.data));
      } else {
        dispatch(getNotifications());
      }
      dispatch(submitQuestionSuccess(response.data.question_id, response.data));
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.detail === `You have already taken this question.`) {
          dispatch(removeQuizQuestion(data.question));
        }
        dispatch(alertActions.createAlert({
          message: error.response.data.detail,
          type: `danger`,
        }));
      } else {
        dispatch(alertActions.createAlert({
          message: `An unknown error occured, please try again later.`,
          type: `danger`,
        }));
      }
      dispatch(submitQuestionFailure(data.question, error.response));
    }
  };
};
